<template>
    <div class="containerInner">
        <div class="productListHeader">
            <div class="headerLeftMenu">
                <span>表示条件</span>
                <span>
                    <input class="searchInputText" type="text" placeholder="グループ名 / 商品名 / 商品コード"
                        v-model="searchKeyword">
                </span>
            </div>
            <div class="headerRightMenu">
                <Button @click="editTotallingTarget(0)">商品グループ 新規登録</Button>
            </div>
        </div>
        <div class="productListContents">
            <ul class="productList">
                <li class="productInfo" v-for="totallingTarget in dispTotallingTargets" :key="totallingTarget.id">
                    <div class="productInfoLeft">
                        <span class="productInfoName" v-if="totallingTarget.name != undefined">{{ totallingTarget.name
                            }}</span>
                        <ul class="productInfoProducts">
                            <li class="productInfoProducts__item" v-for="product in totallingTarget.products"
                                :key="product.id">
                                <div class="productInfoProducts__item-id">[{{ product.id }}<Icon
                                        v-if="product.is_set_product" title="セット商品">dice-multiple-outline</Icon>]</div>
                                <div class="productInfoProducts__item-name">{{ product.name }}</div>
                            </li>
                        </ul>
                    </div>
                    <div class="productInfoRight">
                        <Button @click="editTotallingTarget(totallingTarget.id)">グループ編集</Button>
                        <Button class="editBtn"
                            @click="openUnitsCountModal(totallingTarget.id, totallingTarget.name)">個数集計設定</Button>
                    </div>
                </li>
            </ul>
            <div v-if="dispTotallingTargets.length == 0" class="productListNotFound">
                該当する商品がありません。
            </div>
        </div>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>
        <modal name="TheTotallingTargetItem" :draggable="false" :resizable="false" width="80%" height="99%"
            @closed="cancelEditTotallingTarget">
            <!--
                TODO: modal componentで作成しシステム共通にする
                btn closeはmodal component側で実装する（共通処理のため）
            -->
            <Button close @click="cancelEditTotallingTarget"></Button>
            <TheTotallingTargetItem @modalClosed="cancelEditTotallingTarget"
                :totalling-target-id="editTotallingTargettId" @update-totalling-target-item="fetchTotallingTargets" />
        </modal>

        <!-- 個数集計設定 -->
        <modal name="totalingTargetUnitsCountModal" :draggable="false" :resizable="false" width="80%" height="99%">
            <TotalingTargetUnitsCountModal :totallingTargetId="this.selectedId" :totallingTargetName="this.selectedName"
                @modalClosed="modalClosed('totalingTargetUnitsCountModal')" />
        </modal>
    </div>
</template>

<script>
import _ from 'lodash';
import TheTotallingTargetItem from '@/components/TheTotallingTargetItem.vue'
import TotalingTargetUnitsCountModal from '@/components/TotalingTargetUnitsCountModal.vue'

export default {
    components: {
        TheTotallingTargetItem,
        TotalingTargetUnitsCountModal,
    },
    data() {
        return {
            searchKeyword: '',
            filterKeyword: '',
            totallingTargets: [],
            editTotallingTargettId: null,
            selectedId: null, //個数集計設定用
            selectedName: '',
        }
    },
    mounted: function () {
        this.fetchTotallingTargets();
    },
    methods: {
        fetchTotallingTargets: async function () {
            this.$store.dispatch('loading', true);
            const res = await this.axios.get('/api/totallingTargets');
            const totallingTargets = res.data;
            this.totallingTargets = totallingTargets.map(totallingTarget => {
                const productKeywords = totallingTarget.products.map(
                    product => `${product.id} ${product.name}`.toKeyword()
                ).join(' ');

                totallingTarget._keyword = `${totallingTarget.name} ${productKeywords}`.toKeyword();
                return totallingTarget;
            });

            this.$store.dispatch('loading', false);
        },
        editTotallingTarget: function (totallingTargettId) {
            this.editTotallingTargettId = totallingTargettId;
        },
        cancelEditTotallingTarget: function () {
            this.editTotallingTargettId = null;
        },

        //個数集計設定
        openUnitsCountModal: function (id, name) {
            this.selectedId = id;
            this.selectedName = name;
            this.$modal.show('totalingTargetUnitsCountModal');
        },

        //データを再取得してモーダルを閉じる
        modalClosed(modalName) {
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.$modal.hide(modalName)
        },
    },
    watch: {
        searchKeyword: _.debounce(function (newVal) {
            this.filterKeyword = newVal.toKeyword();
        },
            500
        ),
        editTotallingTargettId: function (editTotallingTargettId) {
            if (editTotallingTargettId == null) {
                this.$modal.hide('TheTotallingTargetItem');
            } else {
                this.$modal.show('TheTotallingTargetItem');
            }
        },
    },
    computed: {
        dispTotallingTargets: function () {
            let totattingTargets = this.totallingTargets;
            const filterKeywordLower = this.filterKeyword.toLowerCase();
            totattingTargets = _.filter(totattingTargets, (totattingTarget) => {
                return totattingTarget._keyword.toLowerCase().indexOf(filterKeywordLower) > -1;
            });

            return totattingTargets;
        },
    }
}
</script>

<style scoped lang="sass">
.containerInner
    display: inline-grid
    grid-template-columns: 1fr
    grid-row-gap: 10px
    grid-template-rows: 75px 1fr

    .productListHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
                .searchInputText
                    margin-left: 20px
                    padding: 10px
                    width: 360px
                    &:focus
                        outline: 2px solid $mainColor
                .searchBtn
                    border: 1px solid $mainColor
                    margin: 0 20px 0 10px
                    padding: 12px
                    width: 60px
                    &:hover
                        border: 1px solid $mainColor
                #unregistered
                    display: none
                .unregisteredCheckBox
                    line-height: 18px
                    padding-left: 25px
                    position: relative
                    &::before
                        background: $whiteColor
                        border: 1px solid $grayColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 15px
                        position: absolute
                        width: 15px
                    &::after
                        border-bottom: 3px solid $mainColor
                        border-right: 3px solid $mainColor
                        content: ''
                        cursor: pointer
                        display: block
                        height: 9px
                        left: 5px
                        margin-top: -8px
                        opacity: 0
                        position: absolute
                        top: 50%
                        transform: rotate(45deg)
                        width: 5px
                #unregistered:checked + .unregisteredCheckBox::after
                    opacity: 1
        .headerRightMenu
            flex: 1 0 auto
    .productListContents
        font-size: 1.2rem
        margin: 10px 140px
        overflow-y: scroll
        .productList
            .productInfo
                background: $whiteColor
                border-bottom: 3px solid #f8f8ff
                color: $grayColor
                display: flex
                padding: 20px 0 20px 30px
                &:last-child
                    border-width: 0px
                .productInfoLeft
                    width: 90%
                .productInfoName
                    display: block
                    font-size: 1.5rem
                    font-weight: 700
                    margin-bottom: 10px
                .productInfoProducts
                    font-size: 1.5rem
                    &__item
                        display: flex
                        margin-bottom: 10px
                        &:last-child
                            margin-bottom: 0
                    &__item-id
                        width: 85px
            .productInfoRight
                position: relative
                width: 10%
                .editBtn
                    margin-top: 8px;
        .productListNotFound
            color: $grayColor
            font-size: 1.4rem
            margin: 20px 140px 0 140px
            text-align: center
    .productListFooter
        margin: 20px 140px 0 140px
        position: relative
        .pageDisp
            font-size: 1.3rem
            line-height: 42px
            right: 15px
            position: absolute
            top: 50%
    .loadingWindow
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
    .vm--modal > .pochi-button__close
        // TODO: modal componentで作成しシステム共通にする
        position: absolute
        top: 10px
        right: 10px
@include sp()
    .containerInner
        .productListHeader
            display: block
            margin: 5px 0 0 10px
            .headerLeftMenu
                span
                    .searchInputText
                        width: 200px
            .headerRightMenu
                margin-top: 10px
        .productListContents
            margin: 30px 0 10px
</style>
